import { render, staticRenderFns } from "./MailDetail.vue?vue&type=template&id=2beccd4d&scoped=true"
import script from "./MailDetail.vue?vue&type=script&lang=js"
export * from "./MailDetail.vue?vue&type=script&lang=js"
import style0 from "./MailDetail.vue?vue&type=style&index=0&id=2beccd4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beccd4d",
  null
  
)

export default component.exports